import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { developerCompassApiRef } from './api/api';
import { DeveloperCompassClient } from './api/client';
import {
  checkoutRouteRef,
  licenseBillingUpdateRouteRef,
  licenseDetailRouteRef,
  licensesRouteRef,
  marketplaceRouteRef,
  rootRouteRef,
} from './routes';

export const developerCompassPlugin = createPlugin({
  id: 'developer-compass',
  apis: [
    createApiFactory({
      api: developerCompassApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ discoveryApi, fetchApi }) {
        return new DeveloperCompassClient({
          discoveryApi,
          fetchApi,
        });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
    marketplace: marketplaceRouteRef,
    checkout: checkoutRouteRef,
    licenses: licensesRouteRef,
    licenseDetail: licenseDetailRouteRef,
    licenseBillingUpdate: licenseBillingUpdateRouteRef,
  },
});

export const DeveloperCompassPage = developerCompassPlugin.provide(
  createRoutableExtension({
    name: 'DeveloperCompassPage',
    component: () =>
      import('./routing/DeveloperCompassRouter').then(
        m => m.DeveloperCompassRouter,
      ),
    mountPoint: rootRouteRef,
  }),
);
